module.exports = __webpack_public_path__ + "static/media/new-loader.c93be1b8.png";